import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import apiClient, { shouldRedirectToLogin } from '../services/api-client';

import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import PersonOffIcon from '@mui/icons-material/PersonOff';

import Button from '@mui/material/Button';
import { Navigate, useNavigate } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import LockClockIcon from '@mui/icons-material/LockClock';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

import CustomSnackbar from '../components/CustomSnackbar';

import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import AppConfig from '../services/app-config';

import Paper from '@mui/material/Paper';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { alpha } from '@mui/material/styles';

export default function Lists({window,setNavbarState, navbarState}) {
  const apiUrl = process.env.REACT_APP_MGO_API_URL;
  const [lists, setLists] = React.useState([]);
  const [expiredLists, setExpiredLists] = React.useState([]);
  const [searchValue, setSearchValue] = React.useState('');
  const [showSearch, setShowSearch] = React.useState(false);
  const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' });
  const [loading, setLoading] = React.useState(true);
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });
  const [tabValue, setTabValue] = React.useState('todos');
  const navigate = useNavigate();
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
  const [itemToDelete, setItemToDelete] = React.useState(null);
  const [moreAnchorEl, setMoreAnchorEl] = React.useState(null);
  const [moreMenuItem, setMoreMenuItem] = React.useState(null);
  const [invalidateDialogOpen, setInvalidateDialogOpen] = React.useState(false);
  const [itemToInvalidate, setItemToInvalidate] = React.useState(null);

  
  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleToggleSearch = () => {
    setShowSearch((prev) => {
      const next = !prev;
      if (!next) {
        setSearchValue('');
      }
      return next;
    });
  };

  const handleTabChange = (event,newValue) => {
    setTabValue(newValue);
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const deleteAccess = (item) => {
    const data = {
      "access_code": item.codigo
    }
    setLoading(true)
    apiClient.post('delete/visit', data, {}, { action: 'delete_visit' })
      .then((response) => {
        if(response.status === 200) {
          fetchVisits(tabValue)
          setLoading(false)
          setSnackbar({ open: true, message: 'Acceso Eliminado', severity: 'success' });
          
        } else if (response.status === 401) {
          setRedirect({ trigger: true, route: '/login' });
        }
      })
      .catch(error => {
        setSnackbar({ open: true, message: 'Error al crear acceso, intente de nuevo en un momento.', severity: 'error' });
        console.error(error);
        handleDrawerToggle()
      })
  }

  const openAccess = (item) => { 
    if (item.estado.toLowerCase() !== "vencido"){
      navigate(`/compartir?code=${item.codigo}`, { state: { accessDetails: item } });
    } else {
      setSnackbar({ open: true, message: 'El acceso ha vencido, no se puede abrir.', severity: 'warning' });
    }
  }

  const fetchVisits = (type) => {
    const endpoint = type === 'historial' ? 'my/visits' : `my/visits/${type}`
    apiClient.get(endpoint, {}, { action: 'fetch_visits' })
      .then((response) => {
        if (response.status === 200) {
          const cts = Math.round(new Date().getTime() / 1000);
          const allLists = response.data.data.reverse()
          if (type === 'active') {
            setLists(allLists)
          } else if (type === 'expired') {
            setExpiredLists(allLists)
          } else if (type === 'historial') {
            // For historial, split the response into active and expired
            const active = allLists.filter(item => 
              (item?.estado || '').toLowerCase() !== 'vencido' && !isUsedVisit(item)
            )
            const expired = allLists.filter(item => 
              (item?.estado || '').toLowerCase() === 'vencido' || isUsedVisit(item)
            )
            setLists(active)
            setExpiredLists(expired)
          }
          setLoading(false)
        } else if (response.status === 401) {
          setRedirect({ trigger: true, route: '/login' });
        }
      })
      .catch(error => {
        console.log(error)
        if (shouldRedirectToLogin(error)) {
          setRedirect({ trigger: true, route: '/login' })
        }
      })
  }


  const getRelativeDayLabel = React.useCallback((epochSeconds) => {
    const date = new Date(epochSeconds * 1000);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) return 'Hoy';
    if (date.toDateString() === tomorrow.toDateString()) return 'Mañana';
    if (date.toDateString() === yesterday.toDateString()) return 'Ayer';
    return null;
  }, []);

  const formatLongSpanishDate = React.useCallback((epochSeconds) => {
    const date = new Date(epochSeconds * 1000);
    try {
      return new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'long' }).format(date);
    } catch (e) {
      return AppConfig.formatDate(epochSeconds);
    }
  }, []);

  const isUsedVisit = React.useCallback((item) => {
    const state = (item?.estado || '').toLowerCase();
    return state !== 'vigente' && state !== 'esperado';
  }, []);

  const getDisplayTimeLabel = React.useCallback((item) => {
    const time = AppConfig.formatHour(item.fecha);
    const state = (item?.estado || '').toLowerCase();
    if (state === 'vigente') return `${time} • Esperado`;
    if (state === 'vencido') return `${time} • Completado`;
    return `${time} • Check-in`;
  }, []);

  const allItems = React.useMemo(() => {
    const combined = [...lists, ...expiredLists];
    const seen = new Set();
    return combined.filter((it) => {
      if (!it || !it.codigo) return false;
      if (seen.has(it.codigo)) return false;
      seen.add(it.codigo);
      return true;
    });
  }, [lists, expiredLists]);

  const filteredAllItems = React.useMemo(() => {
    return allItems.filter(code =>
      code.nombre.toLowerCase().includes(searchValue.toLowerCase())
      || code.codigo.toLowerCase().includes(searchValue.toLowerCase())
    );
  }, [allItems, searchValue]);

  const getItemsForTab = React.useCallback(() => {
    if (tabValue === 'esperados') {
      return lists
        .filter((it) => (it?.estado || '').toLowerCase() === 'vigente')
        .filter((it) => {
          const label = getRelativeDayLabel(it.fecha);
          return label === 'Hoy' || label === 'Mañana' || label === 'Ayer' || label === null;
        });
    }

    if (tabValue === 'historial') {
      const usedFromActive = lists.filter((it) => isUsedVisit(it));
      const base = [...usedFromActive, ...expiredLists];
      return base
        .filter((it) => it)
        .sort((a, b) => (b.fecha || 0) - (a.fecha || 0));
    }

    // todos
    return filteredAllItems
      .filter((it) => {
        const label = getRelativeDayLabel(it.fecha);
        return label === 'Hoy' || label === 'Mañana' || label === 'Ayer';
      })
      .sort((a, b) => (b.fecha || 0) - (a.fecha || 0));
  }, [tabValue, lists, expiredLists, filteredAllItems, getRelativeDayLabel, isUsedVisit]);

  const groupedItems = React.useMemo(() => {
    const items = getItemsForTab();
    const groups = new Map();
    items.forEach((it) => {
      let groupKey = getRelativeDayLabel(it.fecha);
      if (tabValue === 'historial') {
        groupKey = getRelativeDayLabel(it.fecha) || formatLongSpanishDate(it.fecha);
      }
      if (!groupKey) groupKey = 'Otros';
      if (!groups.has(groupKey)) groups.set(groupKey, []);
      groups.get(groupKey).push(it);
    });

    const sortOrder = ['Mañana', 'Hoy', 'Ayer'];
    const keys = Array.from(groups.keys());
    keys.sort((a, b) => {
      const ia = sortOrder.indexOf(a);
      const ib = sortOrder.indexOf(b);
      if (ia !== -1 && ib !== -1) return ia - ib;
      if (ia !== -1) return -1;
      if (ib !== -1) return 1;
      if (tabValue === 'historial') {
        if (a === 'Hoy') return -1;
        if (b === 'Hoy') return 1;
        if (a === 'Ayer') return -1;
        if (b === 'Ayer') return 1;
      }
      return 0;
    });

    return keys.map((k) => ({ title: k, items: groups.get(k) || [] }));
  }, [getItemsForTab, getRelativeDayLabel, formatLongSpanishDate, tabValue]);

  const renderNewCard = (item) => {
    const used = isUsedVisit(item) || (item?.estado || '').toLowerCase() === 'vencido';
    const vehicle = !!item.placa;
    const icon = vehicle ? <DirectionsCarIcon sx={{ fontSize: 24 }} /> : <DirectionsWalkIcon sx={{ fontSize: 24 }} />;

    const leftAvatar = item.face ? (
      <Avatar
        src={`${apiUrl}/img/id/${item.face}`}
        sx={{ width: 48, height: 48, border: '1px solid', borderColor: 'divider' }}
      />
    ) : (
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid',
          borderColor: (theme) => alpha(
            vehicle ? theme.palette.info.main : theme.palette.text.primary,
            theme.palette.mode === 'dark' ? 0.45 : 0.18,
          ),
          bgcolor: (theme) => alpha(
            vehicle ? theme.palette.info.main : theme.palette.text.primary,
            theme.palette.mode === 'dark' ? 0.18 : 0.06,
          ),
          color: 'text.primary',
        }}
      >
        {icon}
      </Box>
    );

    const statusColor = used ? 'success.main' : 'info.main';
    const statusIcon = used ? <CheckCircleIcon sx={{ fontSize: 16, color: statusColor }} /> : <LockClockIcon sx={{ fontSize: 16, color: statusColor }} />;

    return (
      <Paper
        key={item.codigo}
        elevation={0}
        onClick={() => {
          if (used) return;
          openAccess(item);
        }}
        sx={{
          p: 2,
          borderRadius: '10px',
          border: '1px solid',
          borderColor: 'grey.100',
          boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          opacity: used ? 0.85 : 1,
          cursor: used ? 'default' : 'pointer',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: 0 }}>
          {leftAvatar}
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary', lineHeight: 1.2 }} noWrap>
              {item.nombre}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, minWidth: 0 }}>
              {statusIcon}
              <Typography variant="body2" sx={{ color: statusColor, fontWeight: 500 }} noWrap>
                {getDisplayTimeLabel(item)}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {used ? (
            <CheckCircleIcon sx={{ fontSize: 28, color: 'success.main' }} />
          ) : (
            <>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  openAccess(item);
                }}
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: '10px',
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  '&:hover': { bgcolor: 'primary.dark' },
                }}
              >
                <QrCode2Icon />
              </IconButton>
              <IconButton
                onClick={(e) => handleMoreMenuOpen(e, item)}
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: '10px',
                  border: '1px solid',
                  borderColor: 'divider',
                  color: 'text.primary'
                }}
              >
                <MoreVertIcon />
              </IconButton>
            </>
          )}
        </Box>
      </Paper>
    );
  };

  const renderPage = () => {
    const totalCount = groupedItems.reduce((acc, g) => acc + g.items.length, 0);
    if (totalCount > 0) {
      return (
        <Stack spacing={3} sx={{ pb: 10 }}>
          {groupedItems.map((group) => {
            if (group.title === 'Otros') return null;
            return (
              <Box key={group.title}>
                <Typography
                  variant="overline"
                  sx={{
                    fontWeight: 800,
                    color: 'text.secondary',
                    letterSpacing: '0.12em',
                    mb: 1,
                    display: 'block'
                  }}
                >
                  {group.title}
                </Typography>
                <Stack spacing={1.5}>
                  {group.items.map((item) => {
                    if ((item?.estado || '').toLowerCase() === 'vencido') {
                      return (
                        <Box key={item.codigo}>
                          {renderNewCard(item)}
                          {tabValue === 'historial' && (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
                              <Button
                                size="small"
                                color="inherit"
                                onClick={() => handleDeleteConfirmation(item)}
                                startIcon={<DeleteSweepIcon />}
                              >
                                Eliminar
                              </Button>
                            </Box>
                          )}
                        </Box>
                      );
                    }
                    return <Box key={item.codigo}>{renderNewCard(item)}</Box>;
                  })}
                </Stack>
              </Box>
            );
          })}
        </Stack>
      );
    }

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 220px)' }}>
        <Card variant="outlined" sx={{ border: 0, backgroundColor: 'transparent' }} style={{ borderRadius: '10px', textAlign: 'center', width: '100%', paddingTop: '30%', paddingBottom: '40%' }}>
          <CardContent>
            <PersonOffIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
            <Typography variant="h5" component="div" sx={{ mb: 2 }}><b>No tienes visitas para mostrar.</b></Typography>
            <Divider />
            <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>Presiona 'Añadir Nueva Visita' para crear un acceso.</Typography>
          </CardContent>
        </Card>
      </Box>
    );
  }

  const newVisitHandler = () => {
    navigate('/visitas/nueva');
  };

  const handleDeleteConfirmation = (item) => {
    setItemToDelete(item);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirmed = () => {
    if (itemToDelete) {
      deleteAccess(itemToDelete);
    }
    setDeleteDialogOpen(false);
    setItemToDelete(null);
  };

  const handleDeleteCancelled = () => {
    setDeleteDialogOpen(false);
    setItemToDelete(null);
  };

  const handleMoreMenuOpen = (event, item) => {
    event.stopPropagation();
    setMoreAnchorEl(event.currentTarget);
    setMoreMenuItem(item);
  };

  const handleMoreMenuClose = () => {
    setMoreAnchorEl(null);
    setMoreMenuItem(null);
  };

  const handleInvalidateConfirmation = () => {
    if (!moreMenuItem) return;
    setItemToInvalidate(moreMenuItem);
    setInvalidateDialogOpen(true);
    handleMoreMenuClose();
  };

  const handleInvalidateCancelled = () => {
    setInvalidateDialogOpen(false);
    setItemToInvalidate(null);
  };

  const handleInvalidateConfirmed = () => {
    if (!itemToInvalidate) return;
    setLoading(true);
    apiClient
      .post('visit/invalidate', { access_code: itemToInvalidate.codigo }, {}, { action: 'invalidate_visit' })
      .then((response) => {
        if (response.status === 200) {
          setSnackbar({ open: true, message: 'Acceso Anulado', severity: 'success' });
          Promise.all([
            apiClient.get('my/visits/active', {}, { action: 'fetch_visits_active' }),
            apiClient.get('my/visits/expired', {}, { action: 'fetch_visits_expired' }),
          ])
            .then(([activeResponse, expiredResponse]) => {
              if (activeResponse?.status === 200) setLists((activeResponse.data?.data || []).reverse());
              if (expiredResponse?.status === 200) setExpiredLists((expiredResponse.data?.data || []).reverse());
            })
            .finally(() => setLoading(false));
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      })
      .finally(() => {
        setInvalidateDialogOpen(false);
        setItemToInvalidate(null);
      });
  };

  React.useEffect(() => {
    setLoading(true);
    Promise.all([
      apiClient.get('my/visits/active', {}, { action: 'fetch_visits_active' }),
      apiClient.get('my/visits/expired', {}, { action: 'fetch_visits_expired' }),
    ])
      .then(([activeResponse, expiredResponse]) => {
        if (activeResponse?.status === 200) {
          setLists((activeResponse.data?.data || []).reverse());
        }
        if (expiredResponse?.status === 200) {
          setExpiredLists((expiredResponse.data?.data || []).reverse());
        }
      })
      .catch((error) => {
        console.log(error);
        if (shouldRedirectToLogin(error)) {
          setRedirect({ trigger: true, route: '/login' });
        }
      })
      .finally(() => setLoading(false));
    setNavbarState({ ...navbarState, showBack: true, showOptions: false, showSearch: false})
  }, [])

  return (
    <Container maxWidth="sm">
      {redirect.trigger && (
        <Navigate to={redirect.route} replace={true} />
      )}
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleSnackbarClose}
      />
      <Box sx={{ ml: 0, pb: 12 }}>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Box sx={{ position: 'sticky', top: 0, zIndex: 2, bgcolor: 'background.default', pt: 2, pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <IconButton
              onClick={() => navigate(-1)}
              sx={{
                width: 40,
                height: 40,
                ml: -1,
                color: 'text.primary',
                '&:hover': { backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.08) },
              }}
            >
              <ArrowBackIcon sx={{ fontSize: 28 }} />
            </IconButton>
            <Typography sx={{ fontSize: 24, fontWeight: 800, color: 'text.primary', letterSpacing: '-0.02em' }}>
              Gestión de Visitas
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Stack direction="row" spacing={1} sx={{ overflowX: 'auto', pb: 1, flexGrow: 1 }}>
              <Chip
                label="Todos"
                clickable
                color={tabValue === 'todos' ? 'primary' : 'default'}
                variant={tabValue === 'todos' ? 'filled' : 'outlined'}
                onClick={(e) => handleTabChange(e, 'todos')}
                sx={{ fontWeight: 700 }}
              />
              <Chip
                label="Esperados"
                clickable
                color={tabValue === 'esperados' ? 'primary' : 'default'}
                variant={tabValue === 'esperados' ? 'filled' : 'outlined'}
                onClick={(e) => handleTabChange(e, 'esperados')}
                sx={{ fontWeight: 700 }}
              />
              <Chip
                label="Historial"
                clickable
                color={tabValue === 'historial' ? 'primary' : 'default'}
                variant={tabValue === 'historial' ? 'filled' : 'outlined'}
                onClick={(e) => handleTabChange(e, 'historial')}
                sx={{ fontWeight: 700 }}
              />
            </Stack>
            <IconButton
              onClick={handleToggleSearch}
              sx={{
                width: 40,
                height: 40,
                borderRadius: '10px',
                border: '1px solid',
                borderColor: 'divider',
                color: 'text.primary',
              }}
            >
              <SearchIcon />
            </IconButton>
          </Box>
          {showSearch && (
            <TextField
              fullWidth
              size="small"
              id='search'
              sx={{ textAlign: 'center', mb: 0, mt: 1 }}
              label="Buscar"
              variant="outlined"
              value={searchValue}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleToggleSearch}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                style: { borderRadius: '8px' }
              }}
            />
          )}
        </Box>
        {!loading && (
          <Box sx={{ mt: 2 }}>
            {renderPage()}
          </Box>
        )}
      </Box>
      <Box
        sx={{
          position: 'fixed',
          bottom: 88,
          left: 'calc(var(--app-drawer-width, 0px) + (100vw - var(--app-drawer-width, 0px)) / 2)',
          transform: 'translateX(-50%)',
          width: '100%',
          maxWidth: 600,
          px: 2,
          zIndex: 10,
          pointerEvents: 'none'
        }}
      >
        <Button
          variant="contained"
          color="primary"
          fullWidth
          size="large"
          startIcon={<EmojiPeopleIcon />}
          onClick={newVisitHandler}
          sx={{
            height: 56,
            borderRadius: '10px',
            fontWeight: 800,
            pointerEvents: 'auto'
          }}
        >
          Añadir Nueva Visita
        </Button>
      </Box>
      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteCancelled}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Estás seguro de que quieres eliminar el acceso para {itemToDelete?.nombre}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancelled} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleDeleteConfirmed} color="secondary" autoFocus>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>

      <Menu
        anchorEl={moreAnchorEl}
        open={Boolean(moreAnchorEl)}
        onClose={handleMoreMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleInvalidateConfirmation}>Anular Acceso</MenuItem>
      </Menu>

      <Dialog
        open={invalidateDialogOpen}
        onClose={handleInvalidateCancelled}
        aria-labelledby="invalidate-dialog-title"
        aria-describedby="invalidate-dialog-description"
      >
        <DialogTitle id="invalidate-dialog-title">{"Confirmar anulación"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="invalidate-dialog-description">
            ¿Estás seguro de que quieres anular el acceso para {itemToInvalidate?.nombre}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleInvalidateCancelled} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleInvalidateConfirmed} color="error" autoFocus>
            Anular
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
